import { ServerResponseData } from 'app/models/api/response';
import { BaseParser } from 'app/services/api/parsers/base-parser';
import { ParserMap } from 'app/services/api/parsers/response-parser';
import { IdVerification } from 'app/models/api/id-verification';

export class IdVerificationParser extends BaseParser {
    parse(data: ServerResponseData, _included: ServerResponseData[], _parsersMap: ParserMap) {
        const item = super.parseBase(IdVerification, data);
        return item;
    }
}
